import React from "react";
import { Box, Button } from "@material-ui/core";
import PublishIcon from "@material-ui/icons/Publish";
import { exportFileHandler } from "../utils/NetworkHandler";

export const DEFAULT_IMPORT_OPTIONS = Object.freeze({
  keepDeviceCalibrationsDoneAfterExport: true,
  revertDeviceCalibrationsDeletedAfterExport: false,
  keepDeviceCalibrationsModificationsDoneAfterExport: false,
  overrideMicrophoneCalibrations: false,
  overrideBluetoothSpeakerCalibrations: false,
  overrideNotes: false,
  overrideListenings: false,
});

export default function ImportExportFileButtons() {
  const exportButtonHandler = async () => {
    const { data } = await exportFileHandler();
    const jsonString = JSON.stringify(data, null, 2);
    const blob = new Blob([jsonString], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;

    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const date = `${year}-${month}-${day}-time-${hour}-${minute}-${seconds}`;
    const fileName = `calibrations-export-${date}.json`;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        startIcon={<PublishIcon />}
        onClick={() => exportButtonHandler()}
      >
        Eksportuj
      </Button>
    </Box>
  );
}
